import { MsalAuthenticationResult } from "@azure/msal-react";
import { Typography } from "antd";
const { Title } = Typography;
export const ErrorComponent: React.FC<MsalAuthenticationResult> = ({error}) => {
    return <Title level={3} >An Error Occurred: {error ? error.errorCode : "unknown error"}</Title>;
}